import { render } from "./MILESTONE_AT_RISK.vue?vue&type=template&id=561daca4&scoped=true&ts=true"
import script from "./MILESTONE_AT_RISK.vue?vue&type=script&lang=ts"
export * from "./MILESTONE_AT_RISK.vue?vue&type=script&lang=ts"

import "./MILESTONE_AT_RISK.vue?vue&type=style&index=0&id=561daca4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561daca4"]])

export default __exports__